export default __webpack_public_path__ + "static/media/topLeft.57ef6089.png";